// store/auth.js

// import * as dashboard from './user';
import axios from "axios";
import { apis } from '../../apis/admin';
// import router from "../router/routes";

const state = {
    // Additional state if needed
    loadingValue: false,
    candidatesData: [],
}

const mutations = {
    UPDATE_LOADING_STATE(state, value) {
        state.loadingValue = value;
    },

    SET_CANDIDATES_DATA(state, data) {
      state.candidatesData = data
  },
}

const actions = {
    // Additional actions if needed
      getCandidates({ commit }, id) {
            // return
            return new Promise((resolve, reject) => {
                axios
                    .get(axios.defaults.baseURL + apis.GET_CANDIDATES, {
                        headers: {
                          Authorization: "Bearer " + localStorage.getItem("token"),
                        },
                      })
                    .then((res) => {
                        console.log('getCandidates---', res)
                        commit('SET_CANDIDATES_DATA', res.data.data)
                    })
                    .catch((err) => {
                        console.log('getCandidates err', err)
                    })
            })
    },

}

const getters = {
    // Additional getters if needed
}

export default {
    state,
    mutations,
    actions,
    getters,
  };